import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLD from '@/components/base/JsonLD';
import RefinancingCalculator from './components/RefinancingCalculator';
import Breadcrumb from '@/components/base/Breadcrumb';

const schema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Kalkulator refinansowania kredytu – ile zaoszczędzisz? | EXPERT KREDYTOWY',
  description:
    'Porównaj obecną ratę z ratą po refinansowaniu. Kalkulator refinansowania kredytu hipotecznego z pełną analizą oszczędności i zwrotu kosztów. Bezpłatna konsultacja z doradcą kredytowym w Sanoku.',
  url: 'https://kredytpodkarpacie.pl/narzedzia/refinansowanie',
  isPartOf: {
    '@type': 'WebSite',
    name: 'EXPERT KREDYTOWY',
    url: 'https://kredytpodkarpacie.pl',
  },
};

export default function RefinansowaniePage() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLD data={schema} />
      <Navbar />
      <div className="pt-16 md:pt-20">
        <div className="px-4 md:px-8 lg:px-12 mb-4">
          <Breadcrumb />
        </div>
        <main>
          <RefinancingCalculator />
        </main>
      </div>
      <p className="text-center text-[10px] text-foreground-400 py-4 mx-auto max-w-[1440px] px-4 md:px-8 lg:px-16 xl:px-20">
        Zabrania się kopiowania i wykorzystywania | Orsonet Studio 2026
      </p>
      <Footer />
    </div>
  );
}
